function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayDot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 661",
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "#7c7c7c",
      opacity: 0.7
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDot);
export default __webpack_public_path__ + "static/media/gray_dot.dbd856f6a476ff2e2b636e2897e1f2ad.svg";
export { ForwardRef as ReactComponent };